module.exports = __webpack_public_path__ + "static/img/h19.9e5267f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h19.jpg
// module id = 6NT2
// module chunks = 0